/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../Fixes';
import Builder from '../../Builder';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "jpsmirf": {
        "nested": {
          "service": {
            "nested": {
              "GetMerchantStatusRequest": {
                "fields": {}
              },
              "GetMerchantStatusResponse": {
                "fields": {
                  "isEligible": {
                    "type": "bool",
                    "id": 1,
                    "rule": "optional"
                  },
                  "isSmirfFormSubmitted": {
                    "type": "bool",
                    "id": 2,
                    "rule": "optional"
                  },
                  "isOptedIn": {
                    "type": "bool",
                    "id": 3,
                    "rule": "optional"
                  },
                  "smirfSqRateEnabled": {
                    "type": "bool",
                    "id": 4,
                    "rule": "optional"
                  }
                }
              },
              "OptInRequest": {
                "fields": {
                  "isEligible": {
                    "type": "bool",
                    "id": 1,
                    "rule": "optional"
                  }
                }
              },
              "OptInResponse": {
                "fields": {
                  "success": {
                    "type": "bool",
                    "id": 1,
                    "rule": "optional"
                  }
                }
              },
              "ShouldShowDashboardModalRequest": {
                "fields": {}
              },
              "ShouldShowDashboardModalResponse": {
                "fields": {
                  "shouldShowDashboardModal": {
                    "type": "bool",
                    "id": 1,
                    "rule": "optional"
                  }
                }
              },
              "SetDashboardModalShownRequest": {
                "fields": {}
              },
              "SetDashboardModalShownResponse": {
                "fields": {}
              },
              "JpSmirfService": {
                "methods": {
                  "GetMerchantStatus": {
                    "requestType": "squareup.jpsmirf.service.GetMerchantStatusRequest",
                    "responseType": "squareup.jpsmirf.service.GetMerchantStatusResponse"
                  },
                  "OptIn": {
                    "requestType": "squareup.jpsmirf.service.OptInRequest",
                    "responseType": "squareup.jpsmirf.service.OptInResponse"
                  },
                  "ShouldShowDashboardModal": {
                    "requestType": "squareup.jpsmirf.service.ShouldShowDashboardModalRequest",
                    "responseType": "squareup.jpsmirf.service.ShouldShowDashboardModalResponse"
                  },
                  "SetDashboardModalShown": {
                    "requestType": "squareup.jpsmirf.service.SetDashboardModalShownRequest",
                    "responseType": "squareup.jpsmirf.service.SetDashboardModalShownResponse"
                  }
                }
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.jpsmirf?.nested?.service?.nested?.GetMerchantStatusRequest && !$root.nested?.squareup?.nested?.jpsmirf?.nested?.service?.nested?.GetMerchantStatusResponse && !$root.nested?.squareup?.nested?.jpsmirf?.nested?.service?.nested?.OptInRequest && !$root.nested?.squareup?.nested?.jpsmirf?.nested?.service?.nested?.OptInResponse && !$root.nested?.squareup?.nested?.jpsmirf?.nested?.service?.nested?.ShouldShowDashboardModalRequest && !$root.nested?.squareup?.nested?.jpsmirf?.nested?.service?.nested?.ShouldShowDashboardModalResponse && !$root.nested?.squareup?.nested?.jpsmirf?.nested?.service?.nested?.SetDashboardModalShownRequest && !$root.nested?.squareup?.nested?.jpsmirf?.nested?.service?.nested?.SetDashboardModalShownResponse && !$root.nested?.squareup?.nested?.jpsmirf?.nested?.service?.nested?.JpSmirfService) {
  $root.addJSON(jsonData);
}

/**
 * SOURCE GetMerchantStatusRequest @ squareup/jpsmirf/externalservice.proto at 9:1
 */
export const GetMerchantStatusRequest = $root.lookupType('squareup.jpsmirf.service.GetMerchantStatusRequest');
fixType(GetMerchantStatusRequest);
Builder.createAndAttachToType(GetMerchantStatusRequest);
/**
 * SOURCE GetMerchantStatusResponse @ squareup/jpsmirf/externalservice.proto at 11:1
 */
export const GetMerchantStatusResponse = $root.lookupType('squareup.jpsmirf.service.GetMerchantStatusResponse');
fixType(GetMerchantStatusResponse);
Builder.createAndAttachToType(GetMerchantStatusResponse);
/**
 * SOURCE OptInRequest @ squareup/jpsmirf/externalservice.proto at 29:1
 */
export const OptInRequest = $root.lookupType('squareup.jpsmirf.service.OptInRequest');
fixType(OptInRequest);
Builder.createAndAttachToType(OptInRequest);
/**
 * SOURCE OptInResponse @ squareup/jpsmirf/externalservice.proto at 35:1
 */
export const OptInResponse = $root.lookupType('squareup.jpsmirf.service.OptInResponse');
fixType(OptInResponse);
Builder.createAndAttachToType(OptInResponse);
/**
 * SOURCE ShouldShowDashboardModalRequest @ squareup/jpsmirf/externalservice.proto at 40:1
 */
export const ShouldShowDashboardModalRequest = $root.lookupType('squareup.jpsmirf.service.ShouldShowDashboardModalRequest');
fixType(ShouldShowDashboardModalRequest);
Builder.createAndAttachToType(ShouldShowDashboardModalRequest);
/**
 * SOURCE ShouldShowDashboardModalResponse @ squareup/jpsmirf/externalservice.proto at 42:1
 */
export const ShouldShowDashboardModalResponse = $root.lookupType('squareup.jpsmirf.service.ShouldShowDashboardModalResponse');
fixType(ShouldShowDashboardModalResponse);
Builder.createAndAttachToType(ShouldShowDashboardModalResponse);
/**
 * SOURCE SetDashboardModalShownRequest @ squareup/jpsmirf/externalservice.proto at 46:1
 */
export const SetDashboardModalShownRequest = $root.lookupType('squareup.jpsmirf.service.SetDashboardModalShownRequest');
fixType(SetDashboardModalShownRequest);
Builder.createAndAttachToType(SetDashboardModalShownRequest);
/**
 * SOURCE SetDashboardModalShownResponse @ squareup/jpsmirf/externalservice.proto at 48:1
 */
export const SetDashboardModalShownResponse = $root.lookupType('squareup.jpsmirf.service.SetDashboardModalShownResponse');
fixType(SetDashboardModalShownResponse);
Builder.createAndAttachToType(SetDashboardModalShownResponse);
/**
 * SOURCE JpSmirfService @ squareup/jpsmirf/externalservice.proto at 50:1
 */
export const JpSmirfService = $root.lookupService('squareup.jpsmirf.service.JpSmirfService');